define('ProductsIndex/filterFacetsPosition',[
],
function () {

    // On desktop screen size product filter facets (checkboxes for filtering by product options)
    // are on the left size, below the left side navigation.
    // On mobile screen sizes they need to be directly above product index (the area where product
    // tiles are displayed), and below the banner image and text. But the row and column layout of
    // the pagte is such that it places the filters above the banner image and text, which is not
    // good.
    // We use this module to fix that. We have placed the placeholder div at the beginning of the
    // products index layout (where the filters need to be in mobile view), and we're dynamically
    // moving the filters between that position and their natural position in the left column of
    // the page, depending on the current screen size.

    function init() {
        $(window).off("resize.filterFacetsPosition").on("resize.filterFacetsPosition", windowResized);
        windowResized();
    }

    var views = {
        desktop: 1,
        mobile: 2
    };

    var currentView = views.desktop;
    var mobileBreakpoint = 768;

    function windowResized(event) {
        var width = $(window).width();

        if (width < mobileBreakpoint && currentView === views.desktop) {
            // MOVE ELEMENTS FROM DESKTOP TO MOBILE POSITION
            $("#products-filter-desktop").children().appendTo("#products-filter-mobile");
            currentView = views.mobile;
        } else if (width >= mobileBreakpoint && currentView === views.mobile) {
            // MOVE ELEMENTS FROM MOBILE TO DESKTOP POSITION
            $("#products-filter-mobile").children().appendTo("#products-filter-desktop");
            currentView = views.desktop;
        }
    }

    return {
        init: init
    };
});
